var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79324_98039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.602 7.80911L8.29418 5.50127C7.81415 5.02123 7.53721 4.35658 7.53721 3.67345V2.67647C8.14648 2.67647 8.64498 2.17797 8.64498 1.5687C8.64498 0.959432 8.14648 0.460938 7.53721 0.460938H4.58317C3.9739 0.460938 3.47541 0.959432 3.47541 1.5687C3.47541 2.17797 3.9739 2.67647 4.58317 2.67647V3.67345C4.58317 4.35658 4.30623 5.02123 3.8262 5.50127L1.51836 7.80911C1.11218 8.21529 0.890625 8.75071 0.890625 9.30459V9.41537C0.890625 10.5785 1.85069 11.5386 3.01384 11.5386H9.10655C10.2697 11.5386 11.2298 10.5785 11.2298 9.41537V9.30459C11.2298 8.75071 11.0082 8.21529 10.602 7.80911ZM4.34316 6.01822C4.97089 5.39049 5.32168 4.55967 5.32168 3.67345V2.30721C5.32168 2.10412 5.15552 1.93796 4.95243 1.93796H4.58317C4.38008 1.93796 4.21392 1.77179 4.21392 1.5687C4.21392 1.36561 4.38008 1.19945 4.58317 1.19945H7.53721C7.7403 1.19945 7.90647 1.36561 7.90647 1.5687C7.90647 1.77179 7.7403 1.93796 7.53721 1.93796H7.16796C6.96487 1.93796 6.7987 2.10412 6.7987 2.30721V3.67345C6.7987 4.55967 7.14949 5.39049 7.77723 6.01822L8.86653 7.10752H3.25386L4.34316 6.01822ZM10.4913 9.41537C10.4913 10.1723 9.86352 10.8001 9.10655 10.8001H3.01384C2.25687 10.8001 1.62913 10.1723 1.62913 9.41537V9.30459C1.62913 8.93534 1.77684 8.58454 2.03532 8.32607L2.51535 7.84603H9.58658L10.0666 8.32607C10.3251 8.58454 10.4728 8.93534 10.4728 9.30459V9.41537H10.4913Z",
    fill: "#FFB776",
    stroke: "#FFB776",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79324_98039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.8fb8c3f615bbe5c274ba7b2df25941c6.svg";
export { ForwardRef as ReactComponent };